import uuid from "../../../library/uuid.js";
import global from "../../global.js";
import ObjectHandle from "../ObjectHandle.js";

import {simplify} from "svg-utils";

const d3 = global.d3;

const Polygon = function(group, color) {
    this.data = {
        id: `local-${uuid()}`,
        segments: [[]],
        ending: [],
        color: color,
        class: ["node", "polygon", "object", "movable", "removable"]
    };
    this.group = group;
    this.handle = null;
    this.node = null;
    this.line = null;
    this.timer = null;
    this.position = {
        x: 0,
        y: 0
    };
};
Polygon.prototype.render_driver = d3.line().x((d) => d.x).y((d) => d.y).curve(d3.curveLinear);
Polygon.prototype.render = function() {
    const data = this.data.segments.reduce((s1, s2) => s1.concat(s2)).concat(this.data.ending);
    return this.render_driver(simplify(data, 3 / global.scene.root_transform.k, true));
};
Polygon.prototype.draw = function(x, y) {
    this.group.select(`#${this.data.id}`).remove();
    this.handle = this.group.append("g").attr("class", "handle").attr("id", this.data.id);
    this.node = this.handle.append("g").attr("class", this.data.class.join(" "));
    this.data.segments[0].push({x, y});
    this.data.ending[0] = this.data.segments[0][0];
    this.data.ending[1] = this.data.segments[0][0];
    this.line = this.node
        .append("path")
        .attr("stroke", this.data.color).attr("stroke-width", 3)
        .attr("d", this.render());
};
Polygon.prototype.update = function(x, y) {
    let dx = x - this.position.x, dy = y - this.position.y;
    // check size of segment
    if (Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) < 5 / global.scene.root_transform.k) {
        return;
    }

    // add segment
    let N = this.data.segments.length - 1;
    let M = this.data.segments[N].length;
    this.data.segments[N].push({x, y});
    this.data.ending[0] = this.data.segments[N][M];
    this.data.ending[1] = this.data.segments[0][0];
    this.line
        .attr("stroke", this.data.color).attr("stroke-width", 3).attr("stroke-opacity", 0.4)
        .attr("fill", this.data.color).attr("fill-opacity", 0.2)
        .attr("d", this.render());
    this.position.x = x;
    this.position.y = y;
    window.clearTimeout(this.timer);
    this.timer = window.setTimeout(() => {
        let N = this.data.segments.length - 1;
        let M = this.data.segments[N].length - 1;
        this.data.ending[0] = this.data.segments[N][M];
        this.data.ending[1] = this.data.segments[0][0];
        this.data.segments[N] = [this.data.segments[N].shift(), this.data.segments[N].pop()];
        this.data.segments.push([this.data.segments[N][1]]);
        this.line
            .attr("stroke", this.data.color).attr("stroke-width", 3).attr("stroke-opacity", 0.4)
            .attr("fill", this.data.color).attr("fill-opacity", 0.2)
            .attr("d", this.render());
    }, 500);
};
Polygon.prototype.end = function() {
    if (this.timer !== null) {
        window.clearTimeout(this.timer);
        this.timer = null;
    }
    let object_handle = ObjectHandle({
        x: this.position.x,
        y: this.position.y,
        color: this.data.color
    });
    this.node.append(() => object_handle.node());
    return Promise.resolve();
};
Polygon.prototype.is_empty = function() {
    let N = this.data.segments.length - 1;
    return (this.data.segments[N].length === 0);
};
Polygon.prototype.detach = function() {
    this.handle = null;
    this.node = null;
    this.line = null;
};
Polygon.prototype.export = function() {
    return this.handle;
};
export default Polygon;
